import "./Rsvp.module.css";
import Header from "@/reusable_sections/Header";
import EventRegistrationPortal from "./sections/EventRegistrationPortal";
import Footer from "@/reusable_sections/Footer";
export default function RsvpPage() {
  return <div>
      <Header />
      <EventRegistrationPortal />
      <Footer />
    </div>;
}